import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Box,
  Paper,
  Tabs,
  Tab
} from '@mui/material';
import {
  Settings as SettingsIcon,
  People as PeopleIcon
} from '@mui/icons-material';

function ComponentSelector() {
  const navigate = useNavigate();
  const location = useLocation();

  // Determine active tab based on the current URL
  const getActiveTabFromPath = () => {
    const path = location.pathname;
    if (path.includes('/order-sync/orders')) return 0;
    if (path.includes('/order-sync/settings')) return 1;
    return 0; // Default to sync operations
  };

  const [activeTab, setActiveTab] = React.useState(getActiveTabFromPath());

  // Update active tab when location changes
  React.useEffect(() => {
    setActiveTab(getActiveTabFromPath());
  }, [location]);

  // Handle tab change
  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);

    // Navigate to the corresponding route
    switch (newValue) {
    case 0:
      navigate('/order-sync/orders');
      break;
    case 1:
      navigate('/order-sync/settings');
      break;
    default:
      navigate('/order-sync/orders');
    }
  };

  return (
    <Box>
      <Paper elevation={0} sx={{ mb: 3, borderRadius: 2, overflow: 'hidden' }}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          variant="fullWidth"
          indicatorColor="primary"
          textColor="primary"
        >
          <Tab icon={<PeopleIcon sx={{ fontSize: { xs: '20px', sm: '24px', md: '28px' }}} />} label="Orders" sx={{ fontSize: { xs: '10px', sm: '12px', md: '12px', lg: '16px' } }} />
          <Tab icon={<SettingsIcon sx={{ fontSize: { xs: '20px', sm: '24px', md: '28px' }}} />} label="Settings" sx={{ fontSize: { xs: '10px', sm: '12px', md: '12px', lg: '16px' } }} />
        </Tabs>
      </Paper>
    </Box>
  );
}

export default ComponentSelector;
